import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiPropertyValuationValuationBlockAgricultureActivityConstants } from "../../../../../../../shared/constants/api-constants/api-property-valuation-valuation-block-agriculture-activity.constants";
import { ApiPropertyValuationValuationBlockConstants } from "../../../../../../../shared/constants/api-constants/api-property-valuation-valuation-block.constants";
let ValuationBlockAgricultureActivitiesService = class ValuationBlockAgricultureActivitiesService {
    http;
    constructor(http) {
        this.http = http;
    }
    getPropertyValuationValuationBlockAgricultureActivities(params) {
        return this.http.get(ApiPropertyValuationValuationBlockAgricultureActivityConstants.URL, { params })
            .pipe(map(response => {
            return response.value;
        }));
    }
    getValuationBlock(params) {
        return this.http.get(ApiPropertyValuationValuationBlockConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ValuationBlockAgricultureActivitiesService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ValuationBlockAgricultureActivitiesService);
export { ValuationBlockAgricultureActivitiesService };
